import EnfiniNavbar from "@/layouts/EnfiniNavbar";
import { useEffect } from "react";
import { Meta, Title } from "react-head";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import AdcelerateNavbar from "./layouts/AdcelerateNavbar";
import CreatorshieldNavbar from "./layouts/CreatorshieldNavbar";
import EnfinityNavBar from "./layouts/EnfinityNavbar";
import TaskNavbar from "./layouts/TaskNavbar";
import VVVNavbar from "./layouts/VVVNavbar";
import LandingPage from "./pages";
import AdcelerateAboutUs from "./pages/adcelerate/about-us";
import AdcelerateEsign from "./pages/adcelerate/esign";
import AdcelerateMessageUs from "./pages/adcelerate/message-us";
import AdcelerateTerms from "./pages/adcelerate/terms";
import Testimonials from "./pages/adcelerate/testimonials";
import CreatorshieldContactUs from "./pages/creatorshield/contact-us";
import CreatorshieldEsign from "./pages/creatorshield/esign";
import CreatorshieldFAQ from "./pages/creatorshield/faq";
import CreatorshieldLive from "./pages/creatorshield/live";
import SuccessStories from "./pages/creatorshield/success-stories";
import ContactUs from "./pages/enfini/contact-us";
import Esign from "./pages/enfini/esign";
import Terms from "./pages/enfini/terms";
import EnfinityAboutUs from "./pages/enfinity/about-us";
import EnfinityCaseStudies from "./pages/enfinity/case-studies";
import EnfinityContactUs from "./pages/enfinity/contact-us";
import EnfinityContactUsEnfiniBoost from "./pages/enfinity/contact-us-enfiniboost";
import EnfinityContactUsEnfiniPay from "./pages/enfinity/contact-us-enfinipay";
import EnfinityContactUsEnfiniShield from "./pages/enfinity/contact-us-enfinishield";
import EnfinityAboutUsEnfiniBoost from "./pages/enfinity/about-us-enfiniboost";
import EnfinityAboutUsEnfiniPay from "./pages/enfinity/about-us-enfinipay";
import EnfinityAboutUsEnfiniShield from "./pages/enfinity/about-us-enfinishield";
import EnfinityCaseStudiesEnfiniBoost from "./pages/enfinity/case-studies-enfiniboost";
import EnfinityCaseStudiesEnfiniPay from "./pages/enfinity/case-studies-enfinipay";
import EnfinityCaseStudiesEnfiniShield from "./pages/enfinity/case-studies-enfinishield";
import EnfiniShield from "./pages/enfinity/our-solutions/enfinishield";
import EnfiniBoost from "./pages/enfinity/our-solutions/enfiniboost";
import EnfiniPay from "./pages/enfinity/our-solutions/enfinipay";
import EnfiniBoostEsign from "./pages/enfinity/esign/enfiniboost";
import EnfiniShieldEsign from "./pages/enfinity/esign/enfinishield";
import CaseStudy1 from "./pages/task/case-study/1";
import CaseStudy2 from "./pages/task/case-study/2";
import TaskContactUs from "./pages/task/contact-us";
import HireATalent from "./pages/task/hire-a-talent";
import TalentHub from "./pages/task/talent-hub";
import VVVContactUs from "./pages/vvv/contact-us";
import VVVEsign from "./pages/vvv/esign";
import VVVSubmitClip from "./pages/vvv/submit-clip";
import VVVTerms from "./pages/vvv/terms/esign";
import VVVSubmitClipTerms from "./pages/vvv/terms/submit-clip";
import CaseStudies from "./components/creatorshield/success-stories/CaseStudies";
import CaseStudy from "./pages/creatorshield/case-study";
import CSTerms from "./pages/creatorshield/terms";

export default function App() {
  const landingPage = import.meta.env.VITE_LANDING_PAGE;

  useEffect(() => {
    const setTeamColors = (primary, primaryLight, tertiary) => {
      document.documentElement.style.setProperty("--primary", primary);
      document.documentElement.style.setProperty(
        "--primaryLight",
        primaryLight
      );
      document.documentElement.style.setProperty("--tertiary", tertiary);
    };

    const setFavicon = (rel, sizes, href) => {
      let link = document.querySelector(`link[rel="${rel}"][sizes="${sizes}"]`);
      if (!link) {
        link = document.createElement("link");
        link.rel = rel;
        link.sizes = sizes;
        document.head.appendChild(link);
      }
      link.href = href;
    };

    const setManifest = (href) => {
      let link = document.querySelector('link[rel="manifest"]');
      if (!link) {
        link = document.createElement("link");
        link.rel = "manifest";
        document.head.appendChild(link);
      }
      link.href = href;
    };

    switch (landingPage) {
      case "shield":
        setTeamColors("#6D6ED0", "#C7C8FF", "#121B67");
        document.title =
          "EnfiniShield | Copyright claiming service to help you earn";
        setFavicon(
          "apple-touch-icon",
          "180x180",
          "/shield/apple-touch-icon.png"
        );
        setFavicon("icon", "32x32", "/shield/favicon-32x32.png");
        setFavicon("icon", "16x16", "/shield/favicon-16x16.png");
        setManifest("/shield/site.webmanifest");
        break;

      case "pay":
        setTeamColors("#196A0B", "#34A853", "#062800");
        document.title = "EnfiniPay | Best way to get paid as a YouTuber";
        setFavicon("apple-touch-icon", "180x180", "/pay/apple-touch-icon.png");
        setFavicon("icon", "32x32", "/pay/favicon-32x32.png");
        setFavicon("icon", "16x16", "/pay/favicon-16x16.png");
        setManifest("/pay/site.webmanifest");
        break;

      case "boost":
        setTeamColors("#72BCD4", "#92E4FF", "#121B67");
        document.title = "EnfiniBoost | Earn from MSN, YouTube, and more";
        setFavicon(
          "apple-touch-icon",
          "180x180",
          "/boost/apple-touch-icon.png"
        );
        setFavicon("icon", "32x32", "/boost/favicon-32x32.png");
        setFavicon("icon", "16x16", "/boost/favicon-16x16.png");
        setManifest("/boost/site.webmanifest");
        break;

      case "adcelerate":
        setTeamColors("#2170A4", "#5FCAFB", "#0A202F");
        document.title =
          "Adcelerate | Video distribution to MSN (Microsoft Network) | Earn revenue";
        setFavicon(
          "apple-touch-icon",
          "180x180",
          "/adcelerate/apple-touch-icon.png"
        );
        setFavicon("icon", "32x32", "/adcelerate/favicon-32x32.png");
        setFavicon("icon", "16x16", "/adcelerate/favicon-16x16.png");
        setManifest("/adcelerate/site.webmanifest");
        break;

      case "task":
        setTeamColors("#7C3AED", "#A78BFA", "#472187");
        document.title =
          "EnfiniTask | Build your team, save time, and focus on what matters.";
        setFavicon("apple-touch-icon", "180x180", "/task/apple-touch-icon.png");
        setFavicon("icon", "32x32", "/task/favicon-32x32.png");
        setFavicon("icon", "16x16", "/task/favicon-16x16.png");
        setManifest("/task/site.webmanifest");
        break;

      case "enfinity":
        setTeamColors("#1A1A1A", "#757575", "#434242");
        document.title =
          "Enfinity | Revenue and growth tools for YouTube creators";
        setFavicon("apple-touch-icon", "180x180", "/apple-touch-icon.png");
        setFavicon("icon", "32x32", "/favicon-32x32.png");
        setFavicon("icon", "16x16", "/favicon-16x16.png");
        setManifest("/site.webmanifest");
        break;

      case "vvv":
        setTeamColors("#1B25F2", "#343DF6", "#6268ED");
        document.title =
          "Very Viral Videos | Global Viral Content Licensing & Distribution";
        setFavicon("apple-touch-icon", "180x180", "/vvv//apple-touch-icon.png");
        setFavicon("icon", "32x32", "/vvv/favicon-32x32.png");
        setFavicon("icon", "16x16", "/vvv/favicon-16x16.png");
        setManifest("/vvv/site.webmanifest");
        break;

      case "creatorshield":
        setTeamColors("#FF6B35", "#FF8C5A", "#CC5529");
        document.title =
          "CreatorShield | Claim your slice of the $9B piracy pie";
        setFavicon("apple-touch-icon", "180x180", "/creatorshield/apple-touch-icon.png");
        setFavicon("icon", "32x32", "/creatorshield/favicon-32x32.png");
        setFavicon("icon", "16x16", "/creatorshield/favicon-16x16.png");
        setManifest("/creatorshield/site.webmanifest");
        break;

      default:
        setTeamColors("#000000", "#FFFFFF");
        document.title =
          "Enfinity | Revenue and growth tools for YouTube creators";
        setFavicon("apple-touch-icon", "180x180", "/apple-touch-icon.png");
        setFavicon("icon", "32x32", "/favicon-32x32.png");
        setFavicon("icon", "16x16", "/favicon-16x16.png");
        setManifest("/site.webmanifest");
    }
  }, [landingPage]);

  const metaConfig = {
    enfinity: {
      title: "Enfinity | Revenue and growth tools for YouTube creators",
      description:
        "Enfinity empowers YouTube creators with data-driven tools to grow faster, boost engagement, and maximize revenue—all in one powerful platform.",
    },
    boost: {
      title: "EnfiniBoost | Earn from MSN, YouTube, and more",
      description:
        "EnfiniBoost helps creators earn from MSN, YouTube, and top platforms—expand your reach, monetize your content, and grow your digital income effortlessly.",
    },
    shield: {
      title: "EnfiniShield | Copyright claiming service to help you earn",
      description:
        "EnfiniShield protects your content with advanced copyright claiming—secure your earnings and get paid for every view that uses your work.",
    },
    pay: {
      title: "EnfiniPay | Best way to get paid as a YouTuber",
      description:
        "EnfiniPay makes it easy for YouTubers to get paid faster—track revenue, withdraw earnings securely, and simplify your creator payments.",
    },
    task: {
      title:
        "EnfiniTask | Build your team, save time, and focus on what matters.",
      description:
        "EnfiniTask connects you with skilled talents and experts—hire talent fast, manage projects easily, and focus on growing your business.",
    },
    adcelerate: {
      title:
        "Adcelerate | Video distribution to MSN (Microsoft Network) | Earn revenue",
      description:
        "Adcelerate distributes your videos across MSN and premium networks—accelerate visibility, reach new audiences, and earn more from your content.",
    },
    vvv: {
      title:
        "Very Viral Videos | Global Viral Content Licensing & Distribution",
      description:
        "Very Viral Videos (VVV) is a global platform that unites creators, brands, and media through the licensing and distribution of the internet's most captivating viral content, ready for commercial use.",
    },
    creatorshield: {
      title: "CreatorShield | Claim your slice of the $9B piracy pie",
      description:
        "Turn content theft into recurring revenue. Protect your videos and automatically claim royalties when others use your content. Join over 3,500+ creators protecting their content.",
    },
  };

  return (
    <>
      <Meta charSet="utf-8" />
      <Meta name="viewport" content="width=device-width, initial-scale=1" />
      {metaConfig[landingPage] && (
        <>
          <Title>{metaConfig[landingPage].title}</Title>
          <Meta name="description" content={metaConfig[landingPage].desc} />
        </>
      )}

      <Router>
        <Routes>
          {landingPage === "adcelerate" ? (
            <Route path="/" element={<AdcelerateNavbar />}>
              <Route index element={<LandingPage />} />
              <Route path="about-us" element={<AdcelerateAboutUs />} />
              <Route path="message-us" element={<AdcelerateMessageUs />} />
              <Route path="testimonials" element={<Testimonials />} />
              <Route path="esign" element={<AdcelerateEsign />} />
              <Route path="terms-of-service" element={<AdcelerateTerms />} />
            </Route>
          ) : landingPage === "task" ? (
            <Route path="/" element={<TaskNavbar />}>
              <Route index element={<LandingPage />} />
              <Route path="talent-hub/:category" element={<TalentHub />} />
              <Route path="talent-hub" element={<TalentHub />} />
              <Route path="contact-us" element={<TaskContactUs />} />
              <Route path="hire-a-talent" element={<HireATalent />} />
              <Route path="case-study-1" element={<CaseStudy1 />} />
              <Route path="case-study-2" element={<CaseStudy2 />} />
            </Route>
          ) : landingPage === "enfinity" ? (
            <>
              <Route path="/" element={<EnfinityNavBar />}>
                <Route index element={<LandingPage />} />
                <Route path="about-us" element={<EnfinityAboutUs />} />
                <Route path="case-studies" element={<EnfinityCaseStudies />} />
                <Route path="case-study-1" element={<CaseStudy1 />} />
                <Route path="case-study-2" element={<CaseStudy2 />} />
                <Route path="contact-us" element={<EnfinityContactUs />} />
                <Route path="our-solutions/enfiniboost/about-us" element={<EnfinityAboutUsEnfiniBoost />} />
                <Route path="our-solutions/enfinipay/about-us" element={<EnfinityAboutUsEnfiniPay />} />
                <Route path="our-solutions/enfinishield/about-us" element={<EnfinityAboutUsEnfiniShield />} />
                <Route path="our-solutions/enfiniboost/contact-us" element={<EnfinityContactUsEnfiniBoost />} />
                <Route path="our-solutions/enfinipay/contact-us" element={<EnfinityContactUsEnfiniPay />} />
                <Route path="our-solutions/enfinishield/contact-us" element={<EnfinityContactUsEnfiniShield />} />
                <Route path="our-solutions/enfiniboost/case-studies" element={<EnfinityCaseStudiesEnfiniBoost />} />
                <Route path="our-solutions/enfinipay/case-studies" element={<EnfinityCaseStudiesEnfiniPay />} />
                <Route path="our-solutions/enfinishield/case-studies" element={<EnfinityCaseStudiesEnfiniShield />} />
                <Route path="our-solutions/enfinishield" element={<EnfiniShield />} />
                <Route path="our-solutions/enfiniboost" element={<EnfiniBoost />} />
                <Route path="our-solutions/enfinipay" element={<EnfiniPay />} />
                <Route path="our-solutions/enfiniboost/esign" element={<EnfiniBoostEsign />} />
                <Route path="our-solutions/enfinishield/esign" element={<EnfiniShieldEsign />} />
                <Route path="terms-of-service" element={<Terms />} />
              </Route>
            </>
          ) : landingPage === "vvv" ? (
            <>
              <Route path="/" element={<VVVNavbar />}>
                <Route index element={<LandingPage />} />
                <Route path="contact-us" element={<VVVContactUs />} />
                <Route path="esign" element={<VVVEsign />} />
                <Route path="terms-of-service" element={<VVVTerms />} />
                <Route
                  path="terms-of-submission"
                  element={<VVVSubmitClipTerms />}
                />
                <Route path="submit-clips" element={<VVVSubmitClip />} />
              </Route>
            </>
          ) : landingPage === "creatorshield" ? (
            <Route path="/" element={<CreatorshieldNavbar />}>
              <Route index element={<LandingPage />} />
              <Route path="live" element={<CreatorshieldLive />} />
              <Route path="success-stories" element={<SuccessStories />} />
              <Route path="esign" element={<CreatorshieldEsign />} />
              <Route path="contact-us" element={<CreatorshieldContactUs />} />
              <Route path="faq" element={<CreatorshieldFAQ />} />
              <Route path="case-study" element={<CaseStudy />} />
              <Route path="terms-of-service" element={<CSTerms/>} />
            </Route>
          ) : (
            <Route path="/" element={<EnfiniNavbar />}>
              <Route index element={<LandingPage />} />
              <Route path="our-solutions/enfiniboost/about-us" element={<EnfinityAboutUsEnfiniBoost />} />
              <Route path="our-solutions/enfinipay/about-us" element={<EnfinityAboutUsEnfiniPay />} />
              <Route path="our-solutions/enfinishield/about-us" element={<EnfinityAboutUsEnfiniShield />} />
              <Route path="our-solutions/enfiniboost/contact-us" element={<EnfinityContactUsEnfiniBoost />} />
              <Route path="our-solutions/enfinipay/contact-us" element={<EnfinityContactUsEnfiniPay />} />
              <Route path="our-solutions/enfinishield/contact-us" element={<EnfinityContactUsEnfiniShield />} />
              <Route path="our-solutions/enfiniboost/case-studies" element={<EnfinityCaseStudiesEnfiniBoost />} />
              <Route path="our-solutions/enfinipay/case-studies" element={<EnfinityCaseStudiesEnfiniPay />} />
              <Route path="our-solutions/enfinishield/case-studies" element={<EnfinityCaseStudiesEnfiniShield />} />
              <Route path="our-solutions/enfiniboost" element={<EnfiniBoost />} />
              <Route path="our-solutions/enfiniboost/esign" element={<EnfiniBoostEsign />} />
              <Route path="our-solutions/enfinishield" element={<EnfiniShield />} />
              <Route path="our-solutions/enfinishield/esign" element={<EnfiniShieldEsign />} />
              <Route path="esign" element={<Esign />} />
              <Route path="terms-of-service" element={<Terms />} />
              <Route path="contact-us" element={<ContactUs />} />
            </Route>
          )}
        </Routes>
      </Router>
    </>
  );
}
